
<template>
  <div class="">
    <Banner />
    <!-- <TouristTabBar v-if="!userToken" :tourist-active="touristActive" @set-active="setTouristActive" /> -->
    <div class="w120 mc pt20 pb20">
      <OfficeApp :tourist-active="touristActive" />
    </div>
    <div class="w120 mc pt20 pb20 flex-box">
      <div class="w80">
        <OfficeServe :tourist-active="touristActive" />
      </div>
      <div class="flex-1 ml20">
        <OfficeTool :tourist-active="touristActive" />
      </div>
    </div>
    <Sidebar v-if="userToken" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Banner from "@/components/office/Banner";
import TouristTabBar from "@/components/office/TouristTabBar";
import OfficeApp from "@/components/office/OfficeApp";
import OfficeServe from "@/components/office/OfficeServe";
import OfficeTool from "@/components/office/OfficeTool";
import Sidebar from "@/components/messageBox/Sidebar";

export default {
  name: "Office",
  props: [],
  components: {
    Banner,
    TouristTabBar,
    OfficeApp,
    OfficeServe,
    OfficeTool,
    Sidebar
  },
  data() {
    return {
      touristActive: this.userToken ? "" : "tourist"
    };
  },
  computed: {
    ...mapGetters(["userToken"])
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    setTouristActive(value) {
      this.touristActive = value;
    }
  },
  watch: {
    userToken(value) {
      if (value) {
        this.touristActive = "";
      }
    }
  },
  filters: {}
};
</script>

<style scoped>
</style>
